import { useMemo } from "react";
import { getLocalUser } from "../../../components/functions/utilities";
import { IIntegrationPartner, IpNames } from "../../../interfaces/interfaces";
import { useAppSelector } from "../../../redux/reduxHooks";
import { accountSelectIps } from "../utils/connection.util";
import styles from './ConnectionWarning.module.scss';
import { RiErrorWarningFill as InfoIcon } from 'react-icons/ri'


type Props = {
  ip: IIntegrationPartner;
  selectedCustomers: Record<string, any>;
}

const ConnectionWarning = ({ ip, selectedCustomers }: Props) => {

  const currentUser = getLocalUser();
  const { currentClient } = useAppSelector((state) => state.agencyConfig);


  // console.log('selectedCustomers', selectedCustomers);

  const formattedCustomers = useMemo(() => {
    if (Object.keys(selectedCustomers).length === 0) {
      return [];
    } else {
      return Object.keys(selectedCustomers).reduce((prev, key) => {
        const isSelected = selectedCustomers[key]?.selected;
        if (isSelected) {
          prev.push({
            id: key,
            name: selectedCustomers[key]?.details?.name,
          });
        }
        return prev;
      }, [])
    }
  }, [selectedCustomers]);

  return (
    <div className={styles.rootContainer}>
      <div className={styles.bodyContainer}>
        <div className={styles.logoContainer}>
          {ip?.logo ? (
            <img src={ip.logo} alt={`${ip.companyName} logo`} />
          ) : null}
        </div>
        <div className={styles.ipTitle}>
          {`Connect ${ip?.companyName}?`}
        </div>
        <div className={styles.subText}>
          {accountSelectIps.has(ip?.companyName as IpNames) ?
            <>
              The following account(s) will be connected to <br />
              {currentClient?.name}
            </>
            :
            <>
              You're about to connect {ip?.companyName} <br />
              account(s) to <b>{currentClient?.name}</b>.
            </>
          }
        </div>
        {ip?.companyName == IpNames.shopify ? <div className={styles.infoRootContainer}>
          <div className={styles.iconContainer}>
            <InfoIcon />
          </div>
          <div className={styles.infoText}>
            <>Make sure you're logged into {currentClient?.name} Shopify account.</>
          </div>
        </div> : null}

        {accountSelectIps.has(ip?.companyName as IpNames) ?
          <div className={styles.accountsRootContainer}>
            <div className={styles.header}>
              Accounts
            </div>
            <div className={styles.accountsList}>
              {formattedCustomers.map((customer, index) => {
                return (
                  <div className={styles.accountItem}>
                    <div className={styles.accountId}>
                      {customer.id}
                    </div>
                    {customer?.name ? <div className={styles.accountName}>
                      <>({customer.name})</>
                    </div> : null}
                  </div>
                )
              })}
            </div>
          </div> : null}
      </div>
    </div>
  );
}

export default ConnectionWarning;